import { createWebHistory, createRouter } from "vue-router";
import HomeLanding from "@/views/Home/HomeLanding.vue";
import OurProcedure from "@/views/OurProcedure/OurProcedure.vue";
import SuccessStories from "@/views/SuccessStories/SuccessStories.vue";
import UserDashboard from "@/views/Dashboard/UserDashboard.vue";
import ViewNewJoinedMember from "@/views/Dashboard/ViewNewJoinedMember.vue";
import ViewprofileVisitors from "@/views/Dashboard/ProfileVisitors.vue";
import ViewPreviousSearch from "@/views/Dashboard/PreviousSearch.vue";
import AllGrooms from "@/views/Grooms/AllGrooms.vue";
import AllBride from "@/views/Bride/AllBride.vue";
import AllNotifications from "@/views/AllNotifications/AllNotifications.vue";
import ContactUs from "@/views/Contact/ContactUs.vue";
import SearchBy from "@/views/Search/SearchBy.vue";
import HandpickSuggestions from "@/views/Suggestions/HandpickSuggestions.vue";
import ViewProfile from "@/views/Suggestions/ViewProfile.vue";
import ViewContact from "@/views/ViewContact/ViewContact.vue";
import ShortlistedContacts from "@/views/ShortlistedContacts/ShortlistedContacts.vue";
import ViewBiodata from "@/views/ViewBiodata/ViewBiodata.vue";
import DownloadBiodata from "@/views/DownloadBiodata/DownloadBiodata.vue";
import MembershipPlans from "@/views/Plans/MembershipPlans.vue";
import MyProfile from "@/views/MyProfile/MyProfile.vue";
import EditProfile from "@/views/EditProfile/EditProfile.vue";
import MySettings from "@/views/Settings/MySettings.vue";
import ViewOfMyProfile from "@/views/ViewOfMyProfile/ViewOfMyProfile.vue";
import MyId from "@/views/MyId/MyId.vue";
import ViewedContacts from "@/views/ViewedContacts/ViewedContacts.vue";
import MainView from "@/views/main.vue";
import Terms from "@/views/CMS/termsAndConditions.vue";
import ResetPassword from "@/views/Home/resetPassword.vue";
import AboutUs from "@/views/CMS/aboutUs.vue";
import RecentlyViewed from "@/views/MyActivity/RecentlyViewed.vue";
import ShortListed from "@/views/MyActivity/Shortlisted.vue";
import ContactsViewed from "@/views/MyActivity/ContactViewed.vue";
import BlockedUser from "@/views/MyActivity/BlockedUser.vue";
import ReportedUser from "@/views/MyActivity/ReportedUser.vue";
import IntrestSent from "@/views/MyActivity/SentIntrest.vue";
import IntrestRecieved from "@/views/MyActivity/RecievedIntrest.vue";
import SearchList from "@/views/Search/searchlist.vue";
import searchNextPrevious from "@/views/Search/searchNextPrevious.vue";






const routes = [{
    path: "/home",
    name: "HomeLanding",
    component: HomeLanding,
},

{
    path: "/our-procedure",
    name: "OurProcedure",
    component: OurProcedure,
},
{
    path: "/success-stories",
    name: "SuccessStories",
    component: SuccessStories,
},
{
    path: "/contact",
    name: "ContactUs",
    component: ContactUs,
},

{
    path: "/terms",
    name: "Terms",
    component: Terms,
},
{
    path: "/about-us",
    name: "aboutUs",
    component: AboutUs,
},

{
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword,
},

{
    path: '',
    name: "Main",
    component: MainView,
    meta: {
        requiresAuth: true,
    },
    children: [
        {
            path: "",
            name: "UserDashboard-New2",
            component: UserDashboard,
        },

        {
            path: "/dashboard",
            name: "UserDashboard-New",
            component: UserDashboard,
        },
        {
            path: "/dashboard-in/:type",
            name: "UserDashboard",
            component: UserDashboard,
        },
        {
            path: "/view-new-joined-member",
            name: "ViewNewJoinedMember",
            component: ViewNewJoinedMember,
        },
        {
            path: "/view-profile-visitors",
            name: "ViewprofileVisitors",
            component: ViewprofileVisitors,
        },
        {
            path: "/view-previous-search",
            name: "ViewPreviousSearch",
            component: ViewPreviousSearch,
        },
        {
            path: "/search",
            name: "SearchBy",
            component: SearchBy,
        },
        {
            path: "/search/:type",
            name: "SearchByBack",
            component: SearchBy,
        },
        {
            path: "/all-grooms",
            name: "AllGrooms",
            component: AllGrooms,
        },
        {
            path: "/all-bride",
            name: "AllBride",
            component: AllBride,
        },
        {
            path: "/all-notifications",
            name: "AllNotifications",
            component: AllNotifications,
        },
        {
            path: "/handpick-suggestions",
            name: "HandpickSuggestions",
            component: HandpickSuggestions,
        },
        {
            path: "/view-contact",
            name: "ViewContact",
            component: ViewContact,
        },
        {
            path: "/shortlisted-contacts",
            name: "ShortlistedContacts",
            component: ShortlistedContacts,
        },
        {
            path: "/edit-profile",
            name: "EditProfile",
            component: EditProfile,
        },
        {
            path: "/view-biodata",
            name: "ViewBiodata",
            component: ViewBiodata,
        },
        {
            path: "/download-biodata",
            name: "DownloadBiodata",
            component: DownloadBiodata,
        },
        {
            path: "/my-id",
            name: "MyId",
            component: MyId,
        },
        {
            path: "/my-settings",
            name: "MySettings",
            component: MySettings,
        },

        {
            path: "/membership-plans",
            name: "MembershipPlans",
            component: MembershipPlans,
        },
        {
            path: "/my-profile",
            name: "MyProfile",
            component: MyProfile,
        },
        {
            path: "/my-profile-view",
            name: "ViewOfMyProfile",
            component: ViewOfMyProfile,
        },
        {
            path: "/viewed-contacts",
            name: "ViewedContacts",
            component: ViewedContacts,
        },

        // {
        //   path: "/contact-us",
        //   name: "ContactUs",
        //   component: ContactUs,
        // },

        {
            path: "/reset-password",
            name: "ResetPassword",
            component: ResetPassword,
        },
        {
            path: "/profile-view/:uuid",
            name: "ProfileView",
            component: ViewProfile,
        },
        {
            path: "/profile-view/:uuid/:type",
            name: "SelfProfileView",
            component: ViewProfile,
        },
        {
            path: "/activity-profile-view/:uuid/:tab_type/:activity_id",
            name: "SProfileView",
            component: ViewProfile,
        },
        {
            path: "/recently-viewed",
            name: "RecentlyViewed",
            component: RecentlyViewed,
        },
        {
            path: "/shortlisted",
            name: "ShortListed",
            component: ShortListed,
        },
        {
            path: "/contacts-viewed",
            name: "ContactsViewed",
            component: ContactsViewed,
        },
        {
            path: "/blocked-users",
            name: "BlockedUser",
            component: BlockedUser,
        },
        {
            path: "/reported-users",
            name: "ReportedUser",
            component: ReportedUser,
        },
        {
            path: "/intrest-sent",
            name: "IntrestSent",
            component: IntrestSent,
        },
        {
            path: "/intrest-recieved",
            name: "IntrestRecieved",
            component: IntrestRecieved,
        },
        {
            path: "/search-list",
            name: "SearchList",
            component: SearchList,
        },
        {
            path: "/search-list-next-previous/:uuid/:offset",
            name: "searchNextPrevious",
            component: searchNextPrevious,
        },


    ]
}
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (localStorage.getItem("access_token") == null) {
            next({
                path: "/home",
                params: {
                    nextUrl: to.fullPath,
                },
            });
        } else {
            next();
        }
    } else {
        if (to.path === "/") {
            if (localStorage.getItem("access_token") != null) {
                next({
                    path: "/my-profile",
                    params: {
                        nextUrl: to.fullPath,
                    },
                });
            } else {
                next();
            }
        } else {
            next();
        }
    }
});
export default router;